import Vue from 'vue'

const SuccessInstance = Vue.extend(require('./success.vue').default);
let instance = null
let successPromise = null
let successResolve = null

let getInstance = () => {
  return new SuccessInstance({
    el: document.createElement('div')
  })
}

let close = () => {
  instance.close()
  instance.$el.parentNode.removeChild(instance.$el);
  instance = null
  if (successResolve) {
    successResolve(false)
    successResolve = null
  }
  successPromise = null
}

let Success = (info) => {
  if (instance) {
    close()
  }
  instance = getInstance()

  document.body.appendChild(instance.$el);
  successPromise = new Promise((resolve, reject) => {
    successResolve = resolve
  })
  instance.open(info, successResolve)

  return successPromise
}

export default Success
